import Portfolio from "../../components/Portfolio/Portfolio";
import Layout from "../../layout/Layout";
export default function Portfolios() {
  return (
      <Portfolio />
  );
}
